<script lang="ts" setup>
import { ExpandablePanel } from "@frontiers-vue3/public-pages";
import TopicEditor from "~/components/templates/v2/TopicEditor/TopicEditor.vue";

const { specialtyChiefEditors } = useMain();

const isDesktopApp = inject("isDesktopApp") as Ref<boolean>;
</script>
<template>
  <ExpandablePanel
    v-if="specialtyChiefEditors.length"
    title="Specialty Chief Editor"
    :is-open="!isDesktopApp">
    <TopicEditor
      v-for="editor in specialtyChiefEditors"
      :key="editor.loopUserId"
      :editor="editor" />
  </ExpandablePanel>
</template>
<style lang="scss">
.ExpandablePanel {
  @media #{$break-md} {
    height: auto !important;
    padding: spacing(2) spacing(3) !important;
  }

  &__content {
    @media #{$break-md} {
      height: auto !important;
    }

    &--open {
      padding-bottom: 0 !important;
    }
  }

  &__arrow {
    @media #{$break-md} {
      display: none;
      pointer-events: none;
    }
  }
}
</style>
